import { render, staticRenderFns } from "./ImportExcel.vue?vue&type=template&id=27841610"
import script from "./ImportExcel.vue?vue&type=script&lang=js"
export * from "./ImportExcel.vue?vue&type=script&lang=js"
import style0 from "./ImportExcel.vue?vue&type=style&index=0&id=27841610&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports